import gql from 'graphql-tag';

export const coverLetterBlocksFields = gql`
  fragment AllBlockFields on BlockFields {
    title
    employer
    city
    startDate
    endDate
    current
    hideDates
    hideStartDate
    description
    skill
    skillLevel
    label
    url
    school
    degree
    hobbies
    language
    languageLevel
    course
    institution
    fullName
    company
    phone
    email
    drivingLicense
    publicationArticleTitle
    publicationTitle
    publicationDate
    dateOfBirth
    nationality
    visaStatus
    maritalStatus
  }
`;

export const allBlockFields = gql`
  fragment AllBlockFields on BlockFields {
    title
    employer
    city
    startDate
    endDate
    current
    hideDates
    hideStartDate
    description
    skill
    skillLevel
    label
    hideMonth
    url
    showOnHeader
    school
    degree
    hobbies
    language
    languageLevel
    course
    institution
    fullName
    company
    phone
    email
    drivingLicense
    publicationArticleTitle
    publicationTitle
    publicationDate
    dateOfBirth
    nationality
    visaStatus
    maritalStatus
    linkIcon
    showLinkIcon
    showDuration
    remote
  }
`;

export const fullDetails = gql`
  fragment FullDetails on ResumeDetails {
    sectionTitle
    title
    firstName
    lastName
    email
    phone
    userPic
    country
    countryCode
    city
    address
    postalCode
    isValidUserPicture
    professionalSummary
    socialLinks {
      label
      url
    }
  }
`;

export const userFull = gql`
  fragment UserFull on User {
    id
    createdAt
    role
    firstName
    lastName
    bluepillEmail
    email
    emails {
      email
      verified
      primary
    }
    photo
    phone
    address
    city
    postalCode
    country
    onboard
    template
    customerId
    subscriptionId
    showDisclaimer
    initialDevice
    primaryLanguage
    billingVersion
    specialPlans
    pendingSubscription
    domain
    gender
    enableJobTrack
    freeAccessUntil
    isValidUserPicture
    extensionOnboardOption
    isNotWantedPromotionalOffer
    howQuicklyLookingForNewJob
    amountSpendForCareer
    isNeedOfResume
    professionHelpServices
    disableCarrerQuiz
    currentCareerStatus
    agentServiceEnabled
    contactExpert
    isInterestedInResumeWriting
    disableResumeWriting
    isInterestedInResumeReview
    disableResumeReview
    isSubscribedToSendinblue
    isAutoApplyUser
    landingPageVariant
    latestResumeData {
      resumeId
      resumeName
      resumeAuthor
      __typename
    }
    latestPolishedResumeData {
      resumeId
      resumeName
      resumeAuthor
      __typename
    }
    resumeWritingData {
      willingForJobApplications
    }
    applyJobDetails {
      jobTitle
      minimumSalary
      city
      jobStartDate
      jobRoleLevel
      jobType
    }
    autoApplySettings {
      jobTitles
      locations {
        title
        range
      }
      considerRemoteJobs
      blackListedCompanies
      contractType
      pauseSearch
      cancelSearch
      noOfDays
      resumeSearchDate
    }
    bluepillSubscriptionId
    bluepillCustomerId
    bluepillBillingVersion
    bluepillDomain
    isLeadCreated
    isKiluzLeadCreated
    extension {
      defaultActiveResumeId
      currentActiveResumeId
      isExtensionUser
    }
    userFeedbackStatus {
      isFeedbackGiven
      feedbackDate
    }
    gclid
  }
`;

export const slugFull = gql`
  fragment SlugFull on Slug {
    slug
    sourceId
    color
    template
    isPrivate
    updatedAt
    createdAt
  }
`;
